import React, { useState } from "react";
import { Input, Select, DatePicker, Space } from "antd";
import {Button} from '@material-ui/core'
const { RangePicker } = DatePicker;

export default function FilterPanel({ filters, onFilterChange }) {
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false); 
  const [selectedFilter, setSelectedFilter] = useState(null);

  const handleChange = (key, value) => {
    const newValues = { [key]: value }; // substitui completamente os valores anteriores
    setValues(newValues);
  };

  const handleClear = () => {
    setValues({});
    setSelectedFilter(null);
    onFilterChange({});
    setOpen(false); 
  };

  if (!open) {
    return (
      <Button className="btn-success" onClick={() => setOpen(true)}>
        Pesquisar
      </Button>
    );
  }

  return (
    <Space
      style={{}}
      wrap
    >
      {/* Seleção do filtro */}
      <Select
        placeholder="Selecione um filtro"
        value={selectedFilter}
        onChange={(val) => setSelectedFilter(val)}
        style={{ minWidth: selectedFilter ? 100 : 100 }}

      >
        {filters.map((filter) => (
          <Select.Option key={filter.key} value={filter.key}>
            {filter.label}
          </Select.Option>
        ))}
      </Select>

      {/* Campo do filtro escolhido */}
      {selectedFilter &&
        filters.map((filter) => {
          if (filter.key !== selectedFilter) return null;

          switch (filter.type) {
            case "text":
              return (
                <Input
                  key={filter.key}
                  placeholder={filter.label}
                  value={values[filter.key] || ""}
                  onChange={(e) => handleChange(filter.key, e.target.value)}
                  style={{ minWidth: 130 }}
                />
              );
            case "select":
              return (
                <Select
                  key={filter.key}
                  placeholder={filter.label}
                  value={values[filter.key]}
                  onChange={(val) => handleChange(filter.key, val)}
                  style={{ minWidth: 160 }}
                >
                  {filter.options?.map((opt) => (
                    <Select.Option key={opt} value={opt}>
                      {opt}
                    </Select.Option>
                  ))}
                </Select>
              );
            case "date":
              return (
                <DatePicker
                  key={filter.key}
                  value={values[filter.key]}
                  style={{ minWidth: 160 }}
                  format="DD/MM/YYYY"   
                  placeholder="Selecione a data"
                  onChange={(date) => handleChange(filter.key, date)}
                />
              );
            default:
              return null;
          }
        })}

      {/* Botões de ação */}
      <Button type="" className="btn-success" onClick={() => onFilterChange(values)}>
        Aplicar
      </Button>
      <Button onClick={handleClear} className="btn-pesquisar-limpar"s>Limpar</Button>
    </Space>
  );
}
